import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-banner-enquiry-form',
  templateUrl: './banner-enquiry-form.component.html',
  styleUrls: ['./banner-enquiry-form.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HttpClientModule, MatSnackBarModule]
})
export class BannerEnquiryFormComponent implements OnInit {
  @Input() backgroundImageId: string | undefined;
  @Input() loanTypeId: number | null | undefined;
  @Input() serviceName: string | undefined = 'Financial Plan';

  baseUrl = environment.baseUrl;
  backgroundImageUrl: string | undefined;
  submissionSuccess: boolean = false;
  successMessage: string = '';

  enquiryForm!: FormGroup;

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    console.log(this.loanTypeId);

    this.enquiryForm = new FormGroup({
      full_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.minLength(8),
      ]),
      appointment_date: new FormControl(''),
      loan_type_id: new FormControl(this.loanTypeId ?? ''),
      organization_id: new FormControl(1),
      enq_detail_msg: new FormControl('', [Validators.required]),
    });

    this.setBackgroundImage();
  }

  setBackgroundImage(): void {
    switch (this.backgroundImageId) {
      case '1':
        this.backgroundImageUrl = 'url(../../../assets/ba.jpg)';
        break;
      case '2':
        this.backgroundImageUrl = 'url(../../../assets/rp/elderly.jpg)';
        break;
      // Add more cases as needed
      case '3':
        this.backgroundImageUrl =
          'url(../../../assets/cp/father-teaching-sons-home.jpg)';
        break;
      case '4':
        this.backgroundImageUrl =
          'url(../../../assets/Services/childmp/child_weddding.jpg)';
        break;
      case '5':
        this.backgroundImageUrl =
          'url(../../../assets/CM/3d-family-investment-discussion-savings-profits-concept-with-candid-shot-capturing-natural-intera.jpg)';
        break;
      case '6':
        this.backgroundImageUrl = 'url(../../../assets/HE/health-banner.jpg)';
        break;
      case '7':
        this.backgroundImageUrl =
          'url(../../../assets/TP/businessman-businesswoman-make-work-plan.jpg)';
        break;
      case '8':
        this.backgroundImageUrl = 'url(../../../assets/er/er-banner.jpeg)'; // Default image
        break;
    }
  }

  onSubmit() {
    if (this.enquiryForm.valid) {
      const obj = {
        ...this.enquiryForm.value,
      };

      console.log('Form Submission Object:', obj);

      this.http.post(`${this.baseUrl}/add_basic_enquiry`, obj).subscribe({
        next: (res: any) => {
          console.log('Response from API:', res);
          if (res.success) {
            this.successMessage =
              'Thank you for your enquiry! We will get back to you shortly.';
            this.submissionSuccess = true;
            this.enquiryForm.reset();

            // Show success snackbar
            this.snackBar.open('Enquiry submitted successfully!', 'Close', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['success-snackbar'], // Optional custom class
            });
          } else {
            // Show failure snackbar
            this.snackBar.open(
              'Submission failed. Please try again.',
              'Close',
              {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center',
                panelClass: ['error-snackbar'], // Optional custom class
              }
            );
          }
        },
        error: (err: any) => {
          console.log('Error during submission:', err);

          // Show error snackbar
          this.snackBar.open(
            'Error occurred during submission. Please try again.',
            'Close',
            {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['error-snackbar'], // Optional custom class
            }
          );
        },
      });
    }
  }
}
